import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {DragNDropFileDirective} from './drag-n-drop.directive';
import {FileIconComponent} from './icon/file-icon.component';
import {FileListComponent} from './list/file-list.component';
import {FileService} from './file.service';
import {FileSizePipe} from './file-size.pipe';
import {InputFileDirective} from './upload.directive';
import {UIModule} from 'app/ui/ui.module';

@NgModule({
    imports: [
        CommonModule,
        UIModule
    ],
    declarations: [
        DragNDropFileDirective,
        FileIconComponent,
        FileListComponent,
        FileSizePipe,
        InputFileDirective
    ],
    exports: [
        DragNDropFileDirective,
        FileIconComponent,
        FileListComponent,
        FileSizePipe,
        InputFileDirective
    ],
    providers: [
        FileService
    ]
})
export class FilesModule {
}